import React from "react";
import { NeumorphicContainer } from "./NeumorphicContainer";

interface IconButtonProps {
  onPress: () => void;
  isNeumorphic?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
                                                        onPress,
                                                        isNeumorphic = false,
                                                        children,
                                                        className,
                                                      }) => {
  return (
    <button
      onClick={onPress}
      className={`icon-button-base ${className || ""}`}
    >
      {isNeumorphic ? (
        <NeumorphicContainer className="icon-button-neumorphic-container">
          {children}
        </NeumorphicContainer>
      ) : (
        <>{children}</>
      )}
    </button>
  );
};
